import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { ReportCreateComponent } from './report-create/report-create.component';
import { ReportViewComponent } from './report-view/report-view.component';
import { MaterialModule } from '../material/material.module';
import { DistributionCreateComponent } from './distribution-create/distribution-create.component';
import { ReportProcessComponent } from './report-process/report-process.component';
import { ReportDetailsComponent } from './report-details/report-details.component';

const routes: Routes = [
  { path: 'create-report', component: ReportCreateComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  { path: 'view-report', component: ReportViewComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'view-distribution', component: DistributionCreateComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  { path: 'report-process', component: ReportProcessComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  { path: 'report-details', component: ReportDetailsComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }}
];

@NgModule({
  imports: [
    MaterialModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ReportFrameworkRoutingModule { }
